/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { get, post } from '@/plugins/axios'
import { useSource, useSite2Station } from '@/store'

/**
* 创建国际发货
* @param {Object} data
*/
export function createDelivery (data: any) {
  return post('/order/delivery/create', data)
}

/**
* 客户店铺sku列表
* @param {Object} params
*/
export function productSkuList (params: any) {
  return get('/order/shop/product/sku/list', { params })
}

/**
* 客户店铺sku列表
* @param {Object} params
*/
export function getCustomerProductSkuListApi (data: any) {
  return post('/order/shop/product/sku/new/List', data)
}

/**
* 编辑客户店铺sku
* @param {Object} params
*/
export function productSkuEdit (data: any) {
  return post('/order/shop/product/sku/edit', data)
}

/**
* 编辑客户店铺sku
* @param {Object} params
*/
export function shopProductSkuEdit (data: any) {
  return post('/order/shop/product/sku/updateShopProductSku', data)
}

/**
* 根据父级字典key获取下级字典信息集合 获取附加项 贴箱唛 贴标
* @param {Object} params
*/
export function getAdditionalLabel () {
  return get('/customer/data/dict/list', { params: { parentKey: 'delivery_addition' } })
}

/**
* 发货方式
* @param {Object} params
*/
export function intShipConfigList (data: any) {
  return post('/settlement/intShipConfig/getRecommendedLogistics', {
    ...data,
    stationCode: useSite2Station()
  })
}

/**
* 获取预估国际运费
* @param {Object} data
*/
export function getEstimateIntShip (data: any) {
  return post('/settlement/intShipConfig/getEstimateIntShip', data)
}

/**
* 国际发货分页
* @param {Object} data
*/
export function getDeliveryPage (data: any) {
  return post('/order/delivery/page', data)
}

/**
* 国际发货分页-待确认-整单确认查询分页接口
* @param {Object} data
*/
export function getProcessByOrderPage (data: any) {
  return post('/order/delivery/processByOrder/page', data)
}
/**
* 国际发货分页-待确认-整单确认查询分页接口
* @param {Object} data
*/
export function getProcessBySkuPage (data: any) {
  return post('/order/delivery/processBySku/page', data)
}
/**
* 国际发货分页-待确认-整单方式确认
* @param {Object} data
*/
export function confirmProcessByOrder (data: any) {
  return post('/order/delivery/processByOrder/confirm', data)
}
/**
* 国际发货-待确认列表-sku方式确认
* @param {Object} data
*/
export function confirmProcessBySku (data: any) {
  return post('/order/delivery/processBySku/confirm', data)
}

/**
* 通过拣货任务编号查询发货任务信息
* @param {Object} data
*/
export function getDeliveryInfo (params: any) {
  return get('/wms/delivery/task/info', { params })
}

/**
* 补货计划分页
* @param {Object} data
*/
export function ReplenishPlanPage (data: any) {
  return post('/api/replenishPlan/page', data)
}

interface CTD{
  additionalList:any;
  declarationAddress:any;
  distribution:string;
  forwarder:string;
  intForwarderConfigId:string;
  intShipConfigId:string;
  labelTemplateId:string;
  replenishPlanItemList:any;
  shippingType:string;
  title:string;
}
/**
* 创建补货计划
* @param {Object} CTD
*/
export function createReplenishPlan (data: CTD) {
  return post('/api/replenishPlan/createPlan', data)
}

/**
* 提出补货计划
* @param {string} data
*/
export function confirmPlan (data: any) {
  return get('/api/replenishPlan/confirmPlan/' + data)
}

/**
* 取消补货计划
* @param {string} data
*/
export function discardPlan (data:any) {
  return post('/api/replenishPlan/discardPlan/' + data)
}

/**
* 获取标签列表
* @param {Object} params
*/
export function getListByType () {
  return get('/wms/print/listByType', { params: { type: 2 } })
}

/**
* 获取未绑定的商品
* @param {Object} data
*/
//  /api/amazon/product/getUnBind
export function amazonGet (data: any) {
  return post('/api/amazon/product/getAmazonProductByMsku', data)
}

/**
* 绑定亚马逊sku
* @param {Object} data
*/
export function bindAmazonSku (data: any) {
  return post('/order/shop/product/sku/bindAmazonSku', data)
}

/**
* 取消发货
* @param {Object} data
*/
export function cancelDelivery (data: any) {
  return post('/wms/delivery/task/cancelDelivery', data)
}

/**
* 签收
* @param {Object} data
*/
export function signDelivery (data: any) {
  return post('/wms/delivery/task/sign', data)
}

/**
* 申请售后
* @param {Object} data
*/
export function afterSales (data: any) {
  return post('/wms/delivery/task/afterSales', data)
}

/**
* 申请售后
* @param {Object} params
*/
export function afterSalePrice (params: any) {
  return get('/order/customer/platformOrderItem/selectProductdeliveryAfterSalePrice', { params })
}

/**
* 编辑客户店铺sku
* @param {Object} params
*/
export function customerProductMskuEdit (data: any) {
  return post('/order/shop/product/sku/updateCustomerProductMsku', data)
}

/**
* 获取物流轨迹
* @param {Object} params
*/
export function getTrack (params: any) {
  return get('/wms/delivery/task/getTrack', { params })
}

/**
* 查询装箱明细
* @param {Object} params
*/
export function getBoxInfo (params: any) {
  return get('/wms/delivery/task/getBoxInfo', { params })
}

/**
*
编辑客户店铺sku文件
* @param {Object} params
*/
export function editFileFeign (params: any) {
  return post('/order/shop/product/sku/editFileFeign', params)
}

/**
*
批量编辑客户店铺sku文件
* @param {Object} params
*/
export function batchEditFileFeign (params: any) {
  return post('/order/shop/product/sku/batchEditFileFeign', params)
}

/**
*
修改sku条形码文件
* @param {Object} params
*/
export function editBarCode (params: any) {
  return post('/wms/delivery/task/editBarCode', params)
}

/**
*
查询箱唛文件
* @param {Object} params
*/
export function getBoxMarkFile (params: any) {
  return post('/wms/delivery/task/getBoxMarkFile', params)
}

/**
*
上传、修改箱唛文件
* @param {Object} params
*/

export function uploadBoxMarkLink (params: any) {
  return post('/wms/delivery/task/uploadBoxMarkLink', params)
}

// 国际发货售后商品抽检数量
export function getB2bSpotCheckNumsApi (params: any) {
  return post('/wms/delivery/task/getB2bSpotCheckNums', params)
}

/** 国际发货单-待确认处理记录条数提醒接口 */
export function getNoticeCount (params: any) {
  return post('/order/delivery/process/noticeCount', params)
}

/** 订单可用物流列表 */
export function getOrderExpressListApi (params: any) {
  return post('/order/ship/list', params)
}

export function getQryDeliveryNum (params: any) {
  return post('/wms/delivery/task/qryDeliveryNum', params)
}

/**
* 获取海外调拨客户白名单
* @param {Object} params
*/
export function getAutoTransferOverseasCustomerIdsApi (params: any) {
  return get('/wms/base/config/getAutoTransferOverseasCustomerIds', { params })
}
